<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('bill.budget_date_info')"
    icon="res-billtime"
    :res-name="detailData.name"
    :current-tab="params.windowData.currentTab"
    :loaded="loaded"
    :tabs="detailTabs"
    @tab-change="handleTabChange">
    <component
      :is="params.windowData.currentTab"
      :res-id="data.id"
      :id="listId"
      :data="detailData"
      :on-manager="onManager"
      :show-group-actions="false"
      :show-single-actions="false"
      :getParams="getParams"
      :hiddenKindTabs="hiddenKindTabs"
      :defaultDateMode="custom"
      :defaultDate="defaultDate"
      :showBillShared="true"
      :yearFeeTitleYear="defaultDate.year"
      @tab-change="handleTabChange" />
  </base-side-page>
</template>

<script>
import { mapGetters } from 'vuex'
import Overview from '@Bill/views/overview/components'
import Actions from '@/components/PageList/Actions'
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'BillTimeSidePage',
  components: {
    Actions,
    Overview,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('bill.budget_alert_type_cost'), key: 'overview' },
      ],
    }
  },
  computed: {
    ...mapGetters(['isDomainMode', 'scope']),
    listId () {
      switch (this.params.windowData.currentTab) {
        case 'overview':
          return 'OverviewForBillTimeSidePage'
        default:
          return ''
      }
    },
    getParams () {
      return {}
    },
    hiddenKindTabs () {
      if (this.isDomainMode) {
        return ['domain', 'external_project']
      } else if (this.isProjectMode) {
        return ['domain', 'project', 'external_project']
      }
      return ['external_project']
    },
    defaultDate () {
      const time = this.listRowData.month.toString()
      const str = `${time.substr(0, 4)}/${time.substr(4, 2)}/01 00:00:00`
      const moment = this.$moment(str)
      return {
        year: time.substr(0, 4),
        month: this.listRowData.month.toString(),
        data_type: 'day',
        start_date: moment.startOf('month').format('YYYY-MM-DD') + 'TZ',
        end_date: moment.endOf('month').format('YYYY-MM-DD') + 'TZ',
      }
    },
  },
}
</script>
